export const getAuthToken = () => localStorage.getItem('admin_token')
export const setAuthToken = (token) => localStorage.setItem('admin_token', token)
export const removeAuthToken = (token) => localStorage.removeItem('admin_token')